module.exports = __webpack_public_path__ + "img/layer-3.ab0932a5.png";